@if ((card?.template?.gameplay?.type??'') === 'fill') {
  <div class="gameplay__container__box fill__container">
    <mat-card class="card__container">
      <mat-card-content class="card__content">
      <nx-superprep-slide-panel [activePane]="activePane" [duration]="slideDuration">
          <div leftPane>
            <ng-container [ngTemplateOutlet]="fillTemplate"></ng-container>
          </div>
          <div rightPane>
            <ng-container [ngTemplateOutlet]="fillTemplate"></ng-container>
          </div>
      </nx-superprep-slide-panel>
      </mat-card-content>
    </mat-card>
    @if (shouldShowSubmitButton) {
      <button mat-icon-button class="button__container" (click)="onSubmit()">
        <mat-icon aria-hidden="false" aria-label="return" fontIcon="keyboard_return"></mat-icon>
      </button>
    }
  </div>
}

<ng-template #fillTemplate>
  <div class="header__container">
    <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
  </div>
  <ng-container [ngTemplateOutlet]="fillSelectorTemplate"></ng-container>
  <div class="frame32pxspacer"></div>
</ng-template>

<ng-template #headerTemplate>
  @if(shouldShowTopText) {
    <div
      class="header__content topText"
      [style.visibility]="!didAnswer && question?.topText ? 'visible' : 'hidden'"
      [style.margin]="question?.isImage ? '0' : 'initial'"
      [innerHTML]="topText() | safe: 'html'"
    ></div>
  }
  @if (!isAudioOnly) {
    <div
      class="text__content"
      [ngClass]="'questionText'"
      [ngClass]="{ 'play': question?.hasAudio }"
      [style.cursor]="didPlayAudio ? 'pointer' : 'unset'"
      (click)="onPlayButtonTap()"
      [innerHTML]="questionText() | safe: 'html'"
    ></div>
  }
  @if (shouldShowPlayButton) {
    <div class="audio__container">
      <nx-superprep-play-button
        #audioButton
        [duration]="audioDuration"
        [diameter]="playButtonDiameter"
        (action)="onPlayButtonTap($event)"
      >
      </nx-superprep-play-button>
    </div>
  }
  <ng-container
    [ngTemplateOutlet]="translationTemplate"
    [ngTemplateOutletContext]="{
      didAnswer: didAnswer,
      translation: translation(),
      pronunciation: pronunciation(),
      shouldShowTranslation: shouldShowTranslation,
      shouldShowPronunciation: shouldShowPronunciation
    }"
  ></ng-container>
</ng-template>

<ng-template #fillSelectorTemplate>
  <div class="droplistgroup__container">
    @if (!didAnswer) {
      <div class="choice__list__container answerList" [ngClass]="{'web':isWeb}"
        [@fadeOutOnLeave]
        (@fadeOutOnLeave.done)="onAnimationDone($event)"
        [@headShake]="didAnswer && isAllValuesFilled && !isAnswer"
        (@headShake.start)="onAnimationStart($event)"
        (@headShake.done)="onAnimationDone($event)"
      >
        @for (item of answerList; track $index; let index = $index) {
          <div
            class="choice__container__box"
            [ngClass]="{'web':isWeb, 'dotted':!item.isSet, 'disabled':item.disabled, 'active':isActiveItem(item)}"
            [style.text-wrap]="didAnswer ? 'wrap':'nowrap'"
            (click)="clickDrop(item, 'answerList')"
            [innerHTML]="item.getValue(false) | safe: 'html'"
          ></div>
        }
      </div>
      <div class="choice__list__container choiceList"  [ngClass]="{'web':isWeb}" [@fadeOutOnLeave]>
        @for (item of choiceList; track $index; let index = $index) {
          <div
            class="choice__container__box choice selectable"
            [ngClass]="{'web':isWeb}"
            (click)="clickDrop(item, 'choiceList')"
          >
            @if (item.isVisible) {
              <span [innerHTML]="item.getValue(false) | safe: 'html'"></span>
            }
          </div>
        }
      </div>
    }
    @if (didAnswer && isAnimationDone) {
      <div class="choice__list__container answerList" [ngClass]="{'web':isWeb}">
        @for (item of answerList; track $index; let index = $index) {
          <div
            class="choice__container__box"
            [ngClass]="{'web':isWeb, 'dotted':!item.isSet, 'disabled':item.disabled, 'correct':item.isCorrect, 'incorrect':!item.isCorrect}"
            [style.text-wrap]="'wrap'"
            [innerHTML]="item.getValue(false) | safe: 'html'"
          ></div>
        }
      </div>
      <div class="choice__list__container"
        [@fadeInOnEnter]
        [ngClass]="{'web':isWeb}"
        [ngStyle]="{'min-height': '138px'}"
      >
      <span class="choice__container__box" [ngClass]="{'web':isWeb}" [ngStyle]="{'background': 'unset', 'border': 'unset'}"
          [innerHTML]="endText() | safe: 'html'"
        ></span>
      </div>
    }
  </div>
</ng-template>

<ng-template #translationTemplate>
  <div class="translation">
    <p class="translation"
      [style.visibility]="shouldShowTranslation ? 'visible' : 'hidden'"
      [innerHTML]="translation() | safe: 'html'"
    ></p>
    <p class="pronunciation"
      [style.visibility]="shouldShowPronunciation ? 'visible' : 'hidden'"
      [innerHTML]="pronunciation() | safe: 'html'"
    ></p>
  </div>
</ng-template>
